import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trfa-home',
  templateUrl: './trfa-home.component.html',
  styleUrls: ['./trfa-home.component.css']
})
export class TrfaHomeComponent implements OnInit {
  ngOnInit() {
    console.log('TRFA Home Component');
  }
}
